const ItemTypes = {
  WORKFLOW: "workflow",
};

export default ItemTypes;
